import React from "react";
import PropTypes from "prop-types";

// Cell component to render URLs as plain text
const StandardsCell = ({ value }) => <div>{value}</div>;

StandardsCell.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired
};

// Function to format details (severities and URLs)
const formatDetails = (details) => {
  if (!details.urls) return "N/A";

  return (
    <ul style={{ margin: 0, paddingLeft: "1.2em" }}>
      {details.urls.map((url, index) => (
        <li key={index}>{url}</li>
      ))}
    </ul>
  );
};

// Function to extract and format data from the record
export const getUrlsData = (record) =>
  (record.urls || []).map((details, index) => ({
    id: index,
    url: formatDetails(details), // Format the URLs as plain text list
    file: details.path, // Include the file path
  }));

// Static columns definition for table
export const urlsColumns = [
  {
    Header: "Urls",
    accessor: "url",
    Cell: StandardsCell, // Render the URL as plain text
  },
  {
    Header: "File",
    accessor: "file",
  },
];

export const urlsTitle = "category-title-urls";
